import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import Select from 'react-select';
import axios from 'axios';
import './ISS.css';
import 'react-select/dist/react-select.css';
import {
  CardActions, CardContent, Container, Grid, Hidden, Slider,
} from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { getResorts, getRegions, getDictionary } from '../../api/api';
import DiaUkraineButton from './Review/Button';
import Pagination from './Pagination';
import MoCards from './MoCards';

const PrettoSlider = withStyles({
  root: {
    color: '#175E82',
    height: 8,
    width: '90%',
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

class ISS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titles: [],
      regions: [],
      types: [],
      forms: [],
      operatingMode: [],
      category: [],
      capacity: [],
      price: [],
      statusRegistry: [],
      govAtestation: [],
      enabling: [],
      resortName: '',
      IPN: '',
      selectedStatus: '',
      selectedTypes: '',
      selectedOperatingMode: '',
      selectedForms: '',
      selectedCategory: '',
      selectedEnabling: '',
      selectedRegions: '',
      range: [0, 5000],
      data: [],
      errorMessage: false,
      loaderPage: false,
      cardsPerPage: 4,
      currentPage: 1,
      searchActivated: false,
      selectLoader: false,
    };
  }

  componentDidMount() {
    this.StateWithLocalStorage();
    this.defineDevice();
    this.handleSearch();
  }

  StateWithLocalStorage = () => {
    this.setState({
      selectLoader: true,
    });

    axios
      .all([
        getResorts(),
        getRegions(),
        getDictionary(4),
        getDictionary(5),
        getDictionary(1),
        getDictionary(6),
        getDictionary(8),
        getDictionary(9),
        getDictionary(10),
      ])
      .then(
        axios.spread((
          res,
          reg,
          type,
          forms,
          operatingMode,
          category,
          govAtestation,
          statusRegistry,
          enabling,
        ) => {
          this.setState({
            titles: res.data,
            regions: reg.data,
            types: type.data,
            forms: forms.data,
            operatingMode: operatingMode.data,
            category: category.data,
            govAtestation: govAtestation.data,
            statusRegistry: statusRegistry.data,
            enabling: enabling.data,
          });
        }),
      ).finally(() => {
        this.setState({
          selectLoader: false,
        });
      });
  }

  handleChangeDirectories = (name) => (event) => {
    this.setState({ [name]: event });
  };

  handleChange = (event) => {
    const { name, value, checked } = event.target;
    this.setState({ [name]: value || checked });
  };

  handleRange = (e, range) => {
    this.setState({
      range,
    });
  };

  handleSearch = () => {
    this.setState({ errorMessage: false, loaderPage: true });
    const {
      selectedTypes,
      selectedRegions,
      selectedForms,
      selectedOperatingMode,
      selectedCategory,
      selectedStatus,
      resortName,
      selectedEnabling,
      IPN,
      range,
    } = this.state;

    const Search = {
      property_state: selectedStatus,
      title: resortName, // найменування закладу
      location: selectedRegions, // регион
      ownership: selectedForms, // форма власности
      resortType: selectedTypes, // тип закладу
      regime: selectedOperatingMode, // рижим функционування
      commisResult: selectedCategory, // державна атестация
      price: range.join(','), // вартисть лико дня
      childinv: selectedEnabling, // доступность дитячого закладу оздоровлення
      edrpou: IPN, // едрпо
    };
    const headers = {
      'Content-Type': 'application/json',
    };
    axios({
      method: 'post',
      url: '/mop/ips',
      headers,
      data: Search,
    })
      .then((response) => {
        this.setState({
          data: response.data,
          // resortName: '',
          // IPN: '',
          // selectedStatus: '',
          // selectedTypes: '',
          // selectedOperatingMode: '',
          // selectedForms: '',
          // selectedCategory: '',
          // selectedRegions: '',
          // range: [0, 5000],
          // errorMessage: false,
          loaderPage: false,
        });
      })
      .catch((error) => {
        this.setState({ errorMessage: true, loaderPage: false });
      });
    this.setState({ searchActivated: true });
  };

  // pagination functions
  paginate = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  };

  incrementPage = () => {
    const { data, currentPage, cardsPerPage } = this.state;
    const lastPage = Math.ceil(data.length / cardsPerPage);

    if (currentPage < lastPage) {
      this.setState((prevState, props) => ({ currentPage: prevState.currentPage + 1 }));
    }
  };

  decrementPage = () => {
    const { currentPage } = this.state;
    if (currentPage > 1) {
      this.setState((prevState, props) => ({ currentPage: prevState.currentPage - 1 }));
    }
  };

  defineDevice() {
    const deviceWidth = document.documentElement.clientWidth;
    let numOfCards = 2;

    if (deviceWidth >= 1024) numOfCards = 9;
    else if (deviceWidth >= 960) numOfCards = 6;
    else if (deviceWidth >= 800) numOfCards = 4;

    this.setState({ cardsPerPage: numOfCards });
  }

  render() {
    const {
      selectedTypes,
      selectedRegions,
      selectedForms,
      selectedOperatingMode,
      selectedCategory,
      selectedEnabling,
      resortName,
      IPN,
    } = this.state;
    const {
      regions, types, forms, operatingMode, category, range, enabling,
    } = this.state;

    // pagination data
    const {
      data, cardsPerPage, currentPage, searchActivated, loaderPage, selectLoader,
    } = this.state;
    const indexOfLast = currentPage * cardsPerPage;
    const indexOfFirst = indexOfLast - cardsPerPage;
    const currentCards = data ? data.slice(indexOfFirst, indexOfLast) : null;

    return (
      <Container maxWidth="xl" style={{ marginTop: '10px' }}>
        <Backdrop
          style={{
            zIndex: 9999,
            color: '#fff',
          }}
          open={loaderPage}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Grid container justifyContent="center" spacing={2}>
                  <Grid item xs={12} className="text-center pt-3">
                    {' '}
                    <h3>Пошук закладу</h3>
                  </Grid>

                  <Grid item xs={12} mt={4}>
                    <Select
                      value={selectedRegions}
                      name="selectedRegions"
                      onChange={this.handleChangeDirectories('selectedRegions')}
                      options={regions}
                      style={{ borderRadius: '600px' }}
                      placeholder="Регіон"
                      valueKey="id"
                      labelKey="title"
                      simpleValue
                      noResultsText="Помилка серверу"
                      isLoading={selectLoader}
                    />
                  </Grid>
                  <Grid item xs={12} mt={4}>
                    <Select
                      value={selectedTypes}
                      name="selectedTypes"
                      onChange={this.handleChangeDirectories('selectedTypes')}
                      options={types}
                      placeholder="Тип закладу"
                      style={{ borderRadius: '600px' }}
                      valueKey="code"
                      labelKey="name"
                      simpleValue
                      noResultsText="Помилка серверу"
                      isLoading={selectLoader}
                    />
                  </Grid>

                  <Grid item xs={12} mt={4}>
                    <Select
                      value={selectedOperatingMode}
                      name="selectedOperatingMode"
                      onChange={this.handleChangeDirectories(
                        'selectedOperatingMode',
                      )}
                      options={operatingMode}
                      placeholder="Режим функціонування"
                      // style={mainStyles.select}
                      // className="select"
                      valueKey="code"
                      style={{ borderRadius: '600px' }}
                      labelKey="name"
                      simpleValue
                      noResultsText="Помилка серверу"
                      isLoading={selectLoader}
                    />
                  </Grid>

                  <Grid item xs={12} mt={4}>
                    <Select
                      value={selectedForms}
                      name="selectedForms"
                      onChange={this.handleChangeDirectories('selectedForms')}
                      options={forms}
                      placeholder="Форма власності"
                      valueKey="code"
                      style={{ borderRadius: '600px' }}
                      labelKey="name"
                      simpleValue
                      noResultsText="Помилка серверу"
                      isLoading={selectLoader}
                    />
                  </Grid>

                  <Grid item xs={12} mt={4}>
                    <Select
                      value={selectedCategory}
                      name="selectedCategory"
                      onChange={this.handleChangeDirectories(
                        'selectedCategory',
                      )}
                      options={category}
                      placeholder="Держана атестація"
                      valueKey="code"
                      labelKey="name"
                      style={{ borderRadius: '600px' }}
                      simpleValue
                      noResultsText="Помилка серверу"
                      isLoading={selectLoader}
                    />
                  </Grid>

                  <Grid item xs={12} mt={4}>
                    <Select
                      value={selectedEnabling}
                      name="selectedCategory"
                      onChange={this.handleChangeDirectories(
                        'selectedEnabling',
                      )}
                      options={enabling}
                      placeholder="Доступність для дітей з інвалідністю"
                      valueKey="code"
                      style={{ borderRadius: '600px' }}
                      labelKey="name"
                      simpleValue
                      noResultsText="Помилка серверу"
                      isLoading={selectLoader}
                    />
                  </Grid>

                  <Grid item xs={12} mt={4}>
                    <input
                      style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        fontSize: '14px',
                        borderRadius: '600px',
                      }}
                      type="text"
                      className="form-control"
                      name="resortName"
                      value={resortName}
                      onChange={this.handleChange}
                      placeholder="Найменування закладу"
                    />
                  </Grid>

                  <Grid item xs={12} mt={4}>
                    <input
                      style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        fontSize: '14px',
                        borderRadius: '600px',
                      }}
                      type="text"
                      className="form-control"
                      name="IPN"
                      value={IPN}
                      onChange={this.handleChange}
                      placeholder="Код ЄДРПОУ"
                    />
                  </Grid>

                  <Grid item xs={12} mt={4}>
                    <span className="card-subtitle">Вартість ліжко-дня</span>
                    <PrettoSlider
                      value={range}
                      onChange={this.handleRange}
                      valueLabelDisplay="auto"
                      color="success"
                      marks={[
                        { value: 0, label: '0' },
                        { value: 5000, label: '5000' },
                      ]}
                      max={5000}
                      min={0}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions>
                <div className="col-12  mt-3 text-center">
                  <DiaUkraineButton onClick={this.handleSearch}>
                    Шукати
                  </DiaUkraineButton>
                  {this.state.errorMessage && (
                    <div style={{ fontSize: '24px' }}>Помилка серверу</div>
                  )}
                </div>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12} md={8}>
            <Grid container spacing={2}>
              {data && (
                <MoCards data={currentCards} handleClick={this.handleClick} />
              )}
            </Grid>
          </Grid>
          {data.length > 0 && (
            <>
              <Hidden only={['xs']}>

                <Grid item xs={12} md={4} />
              </Hidden>
              <Grid item xs={12} md={8}>
                {searchActivated && currentCards && (
                <Pagination
                  cardsPerPage={cardsPerPage}
                  totalCards={data.length}
                  paginate={this.paginate}
                  incrementPage={this.incrementPage}
                  decrementPage={this.decrementPage}

                />
                )}
              </Grid>
            </>
          )}

        </Grid>
      </Container>
    );
  }
}
export default ISS;
